export function formatArticleType(value = '') {
  return String(value)
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function formatAuthors(authors = []) {
  return authors.map((author) => author.name).filter(Boolean).join(', ');
}

export function stripHtml(value = '') {
  return String(value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function formatIssueLabel(issue, fallbackArticle) {
  if (issue) return `Vol. ${issue.volume}, Issue ${issue.issueNumber}`;
  if (fallbackArticle?.volume && fallbackArticle?.issueNumber) return `Vol. ${fallbackArticle.volume}, Issue ${fallbackArticle.issueNumber}`;
  if (fallbackArticle?.volume) return `Vol. ${fallbackArticle.volume}`;
  return 'Ahead of Print';
}

export function normalizeArticle(article = {}) {
  const issue = article.issue;
  return {
    id: article._id,
    title: article.title,
    type: article.articleType,
    authors: formatAuthors(article.authors || []),
    authorList: article.authors || [],
    volume: formatIssueLabel(issue, article),
    year: issue?.year || (article.publishedAt ? new Date(article.publishedAt).getFullYear() : ''),
    abstract: stripHtml(article.abstract),
    abstractHtml: article.abstract,
    keywords: article.keywords || [],
    imageUrl: article.imageUrl,
    pdfUrl: article.pdfUrl,
    publishedAt: article.publishedAt,
    pageRange: article.pageRange,
    doi: article.doi,
    downloads: article.downloads || 0,
    views: article.views || 0,
    issue,
  };
}

export function normalizeIssue(issue = {}) {
  const issueSummary = {
    _id: issue._id,
    volume: issue.volume,
    issueNumber: issue.issueNumber,
    season: issue.season,
    year: issue.year,
    title: issue.title,
  };
  return {
    id: issue._id,
    raw: issue,
    volume: `Vol. ${issue.volume}`,
    issueNumber: issue.issueNumber,
    season: issue.season,
    year: issue.year,
    title: issue.title,
    description: issue.description,
    articleCount: issue.articleCount ?? issue.articles?.length ?? 0,
    upcoming: !issue.isPublished,
    coverImage: issue.coverImageUrl,
    articles: (issue.articles || []).map((article) => normalizeArticle({ ...article, issue: article.issue || issueSummary })),
  };
}
